import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-deep-cocoa/10 last:border-0" data-id="element-32">
      <button onClick={onToggle} className="w-full py-4 flex items-center justify-between text-left group" data-id="element-33">
        <span className="text-sm font-medium text-deep-cocoa group-hover:text-champagne-gold transition-colors" data-id="element-34">
          {question}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-deep-cocoa/60 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-35" />
      </button>

      {isOpen && <div className="pb-4 animate-fade-in" data-id="element-36">
          <p className="text-sm text-deep-cocoa/80 leading-relaxed" data-id="element-37">{answer}</p>
        </div>}
    </div>;
}
export function MiniFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto es un producto físico?',
    answer: 'No, es 100% digital. Recibirás un ebook en PDF y acceso a un manual operativo que puedes leer desde tu celular, tablet o computadora. No hay envíos ni esperas.'
  }, {
    question: '¿Qué necesito para usarlo?',
    answer: 'Solo necesitas tu celular y conexión a internet. La guía está diseñada para que cualquier mujer pueda seguirla, sin importar tu experiencia previa con TikTok o ventas.'
  }, {
    question: '¿Tengo que invertir dinero extra?',
    answer: 'No. La guía te enseña a empezar sin inversión inicial. Puedes comenzar a ganar dinero con lo que ya tienes: tu celular y tu cuenta de TikTok.'
  }, {
    question: '¿Cuándo recibo el acceso?',
    answer: 'Inmediatamente después de confirmar tu pago. Recibirás un correo con el link de descarga y las instrucciones de acceso en menos de 2 minutos.'
  }];
  return <section className="max-w-lg mx-auto px-4 pb-8" data-id="element-38">
      <div className="bg-white rounded-xl p-5 shadow-sm" data-id="element-39">
        <h3 className="text-lg font-semibold text-deep-cocoa mb-4" data-id="element-40">
          Preguntas frecuentes
        </h3>

        <div data-id="element-41">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-42" />)}
        </div>
      </div>
    </section>;
}